import { useEffect, useState } from 'react';
import { Table, Input, Select, Button, Tag, message, Popconfirm } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../../api/axios';
import './admin.css';

export default function AdminServices() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState(null);
  const [types, setTypes] = useState([]);

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (search) params.search = search;
      if (typeFilter) params.type = typeFilter;
      const r = await api.get('/admingov/services', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => {
    api.get('/admingov/service-types').then(r => setTypes(r.data.data)).catch(() => {});
  }, []);
  useEffect(() => { setPage(1); fetchData(1); /* eslint-disable-next-line */ }, [search, typeFilter]);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admingov/services/${id}`);
      message.success("O'chirildi"); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Xizmat nomi', dataIndex: 'name', render: v => <span style={{ fontWeight: 600 }}>{v || '—'}</span> },
    { title: 'Turi', dataIndex: 'type_name', render: v => v ? <Tag color="purple">{v}</Tag> : '—' },
    { title: 'Biznes', dataIndex: 'business_name', render: v => v || '—' },
    { title: 'Viloyat', dataIndex: 'region', render: v => v || '—' },
    { title: 'Manzil', dataIndex: 'address', ellipsis: true, render: v => v || '—' },
    {
      title: 'Amal', width: 70, fixed: 'right',
      render: (_, r) => (
        <Popconfirm title="O'chirishni tasdiqlaysizmi?" okText="Ha" cancelText="Yo'q" onConfirm={() => handleDelete(r.id)}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <div className="admin-toolbar">
        <Input placeholder="Xizmat nomi bo'yicha qidirish" prefix={<SearchOutlined />} allowClear
          value={search} onChange={e => setSearch(e.target.value)} style={{ width: 280 }} />
        <Select placeholder="Xizmat turi" allowClear style={{ width: 200 }} value={typeFilter} onChange={setTypeFilter}
          options={types.map(t => ({ label: t.name, value: t.id }))} />
        <span style={{ marginLeft: 'auto', color: 'var(--a-muted)', fontSize: 13 }}>Jami: <b>{total}</b></span>
      </div>
      <div className="admin-table-card">
        <Table dataSource={data} columns={columns} rowKey="id" loading={loading} size="middle" scroll={{ x: 800 }}
          pagination={{ current: page, total, pageSize: 20, showSizeChanger: false,
            onChange: p => { setPage(p); fetchData(p); } }} />
      </div>
    </div>
  );
}
